import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import { ShopFloorDataService } from 'src/app/services/shopFloorData.service';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import * as moment from 'moment';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DtServiceService } from 'src/app/services/dtService.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Component({
  selector: 'app-operator-execution-form',
  templateUrl: './operator-execution-form.component.html',
  styleUrls: ['./operator-execution-form.component.scss'],
})
export class OperatorExecutionFormComponent implements OnInit {
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  spinnerText: string = '';
  breadcrumList!: any;
  groups!: any[];
  filteredGroups!: any[];
  plants!: any[];
  filteredPlants!: any[];
  @ViewChild('operationimageViewModal')
  private operationimageViewModal!: TemplateRef<any>;
  @ViewChild('technicianimageViewModal')
  private technicianimageViewModal!: TemplateRef<any>;
  operatorForm = new FormGroup({
    group: new FormControl('', [Validators.required]),
    plant: new FormControl('', [Validators.required]),
    line: new FormControl('', [Validators.required]),
    unit: new FormControl('', [Validators.required]),
    assembly: new FormControl(''),
    subAssembly: new FormControl(''),
    component: new FormControl(''),
    status: new FormControl('', [Validators.required]),
    woType: new FormControl('', [Validators.required]),
    failMode: new FormControl('', [Validators.required]),
    spare: new FormControl('', [Validators.required]),
    machineBreakdown: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    TimeStamp: new FormControl('', [Validators.required]),
    StartTime: new FormControl(''),
    CompleteTime: new FormControl(''),
    ClosedAt: new FormControl(''),
    TechRemark: new FormControl(''),
    workPermit: new FormControl(''),
  });
  formDirective: any;
  imageName: string = '';
  woStatus: any = [];
  woType: any = [];
  filteredWoType: any = [];
  failMode: any = [];
  filteredFailMode: any = [];
  operator: any = {
    line: '',
    units: '',
    assembly: '',
    subAssembly: '',
    component: '',
    Group: '',
    Plant: '',
    TimeStamp: new Date(),
    WOStatus: 1,
    WOType: '',
    FailureMode: '',
    SpareParts: false,
    MachineBreakdown: true,
    Remark: '',
    UploadPicture: [],
    createdBy: '',
    RequestedBy: '',
    lineName: '',
    unitName: '',
    assemblyName: '',
    subAssemblyName: '',
    componentName: '',
    displayMachine: '',
    WorkPermit: false,
  };
  techEntryValues: any;
  userGroup: any = 0;
  temp: any = {
    assembly: '',
    subAssembly: '',
    component: '',
  };
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('picker') picker: any;
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  updateOrderprocessingData = false;
  isPlantGroupModelVisible: boolean = false;
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;
  operatorData: any;
  index: any;
  isEdit: boolean = false;
  operatorObj: any;
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  EditFileData: any = [];
  permisson!: any;
  blobStorageUrl: string = '';
  isView: boolean = false;
  disable: boolean = false;
  LineList: any = [];
  LineFilterList: any = [];
  LineAllList: any = [];
  UnitList: any = [];
  UnitFilterList: any = [];
  UnitAllList: any = [];
  AssemblyList: any = [];
  AssemblyFilterList: any = [];
  AssemblyAllList: any = [];
  SubAssemblyList: any = [];
  SubAssemblyFilterList: any = [];
  SubAssemblyAllList: any = [];
  ComponentList: any = [];
  ComponentFilterList: any = [];
  ComponentAllList: any = [];
  isAccess = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_ACCESS;
  isWrite = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_CREATE;
  isUpdate = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_UPDATE;
  isDelete = ApplicationPermission.OPERATOR_EXECUTION_WINDOW_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  NewUnitList: any;
  NewUnitFilterList: any;

  constructor(
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi,
    private toaster: ToastrService,
    private router: Router,
    private operatorExecutionService: OperatorExecutionService,
    private managerExecutionService: ManagerExecutionService,
    private prevConfigurationService: PrevConfigurationService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private rmconfigurationService: RMconfigurationService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
  }

  ngOnInit(): void {
    this.getLangWords();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.operator.createdBy = this.userSession?.userCode;
    this.operator.Group = this.groupSession?.groupCode;
    this.operator.Plant = this.plantSession?.plantCode;
    this.woStatus = this.operatorExecutionService.getWoStatusList();
    this.getTreeMasterData();
    if (!this.isEdit) {
      this.getOperatorMasterData('');
    }
    setTimeout(() => {
      this.operatorObj = this.managerExecutionService.getManagerData();
      if (this.operatorObj) {
        this.isEdit = true;
        this.isView =
          this.operatorObj.WOStatus === 6 ||
            this.operatorObj.WOStatus === 'ReOpen'
            ? true
            : this.operatorObj.isView;

        this.operator.TimeStamp = this.operatorObj.TimeStamp;

        this.findOperatorData();
        this.getTreeMasterData();
      } else this.woStatus.pop();
      if (this.operatorObj && this.operatorObj.assignUser !== '') {
        this.disable = true;
      }
    }, 1000);
  }

  // img popup
  imgview(e: any) {
    let dialogRef = this.dialog.open(this.operationimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  oncloseimg() {
    this.dialog.closeAll();
  }
  imgview1(e: any) {
    let dialogRef = this.dialog.open(this.technicianimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  oncloseimg1() {
    this.dialog.closeAll();
  }
  // img popup

  // getUnitData() {
  //   const key = {
  //     PL_ID: this.operatorForm.get('line'),
  //     PlantCode: this.plantSession?.plantCode,
  //     userCode: this.userSession?.userCode,
  //   };
  //   this.spinner.show();
  //   this.rmconfigurationService.getUnitData(key).subscribe(
  //     (data: any) => {
  //       this.spinner.hide();
  //       this.NewUnitList = data.lstUnit;
  //       this.NewUnitFilterList = this.NewUnitList.slice();
  //     },
  //     (error: any) => {
  //       this.spinner.hide();
  //       this.toaster.error('Error', error.message);
  //     }
  //   );
  // }

  getUnitData(): Promise<void> {
    return new Promise((resolve, reject) => {
      const key = {
        PL_ID: this.operatorForm.get('line')?.value,
        PlantCode: this.plantSession?.plantCode,
        userCode: this.userSession?.userCode,
      };

      this.spinner.show();
      this.rmconfigurationService.getUnitData(key).subscribe(
        (data: any) => {
          this.spinner.hide();
          this.NewUnitList = data.lstUnit;
          this.NewUnitFilterList = this.NewUnitList.slice();
          resolve();  // Resolving the promise once data is fetched
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error('Error', error.message);
          reject(error);  // Rejecting the promise in case of an error
        }
      );
    });
  }


  findOperatorData() {
    this.spinnerText = 'Fetching Manager Data';
    this.spinner.show();
    this.operatorExecutionService
      .findOperatorData(this.operatorObj.WOId)
      .subscribe(
        (res: any) => {
          if (res.result) {
            if (res.result.techExc) {
              this.techEntryValues = res.result.techExc;
              this.techEntryValues.StartTime = this.techEntryValues.StartTime
                ? moment(this.techEntryValues.StartTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '';
              this.techEntryValues.CompleteTime = this.techEntryValues
                .CompleteTime
                ? moment(this.techEntryValues.CompleteTime).format(
                  'DD/MM/YYYY hh:mm a'
                )
                : '';
              const chkReOpen = this.woStatus.find((stat: any) => stat.id == 6);
              if (!chkReOpen) this.woStatus.push({ id: 6, title: 'ReOpen' });
            }
            if (this.isEdit = true) {
              // Add this logic as per the instructions of Irfan Bhai and Nawras for Ticket No. 481.
              this.woStatus = this.woStatus.filter(
                status => status.id !== 4
              );
            }
            this.operator.units = res.result.units ? res.result.units.puId : '';
            this.operator.ID = res.result.ID;
            this.operator.line = res.result.line ? res.result.line.plId : '';
            this.operator.Remark = res.result.Remark;
            this.operator.WOType = parseInt(res.result.WOType.ID);
            this.operator.FailureMode = parseInt(res.result.FailureMode.ID);
            this.operator.SpareParts = parseInt(res.result.SpareParts);
            this.operator.WOStatus = parseInt(res.result.WOStatus);
            this.operator.Group = this.groupSession?.groupCode;
            this.operator.Plant = this.plantSession?.plantCode;
            this.operator.ClosedAt = res.result.ClosedAt
              ? moment(res.result.ClosedAt).format('DD/MM/YYYY hh:mm a')
              : '';
            this.operator.MachineBreakdown = res.result.MachineBreakdown;
            this.operator.WorkPermit = res.result.WorkPermit;
            this.operator.displayMachine = '';
            this.operator.displayMachine += res.result.line
              ? res.result.line.plDesc
              : '';
            if (res.result.units)
              this.operator.displayMachine += '/' + res.result.units.puDesc;
            if (res.result.assembly) {
              this.operator.displayMachine +=
                '/' + res.result.assembly.assblyDesc;
              this.operator.assembly = res.result.assembly.assblyId;
            }
            if (res.result.subAssembly) {
              this.operator.displayMachine +=
                '/' + res.result.subAssembly.sAsblyDesc;
              this.operator.subAssembly = res.result.subAssembly.sAssblyId;
            }
            if (res.result.component) {
              this.operator.displayMachine +=
                '/' + res.result.component.componentName;
              this.operator.component = res.result.component.componentId;
            }
            let OperatorUploadFiles: any = [];
            if (res.result.UploadPicture) {
              OperatorUploadFiles = res.result.UploadPicture.split(',');
              for (let i = 0; i < OperatorUploadFiles.length; i++) {
                this.EditFileData.push({ ImageSrc: OperatorUploadFiles[i] });
              }
            }
            this.woType = res.WOTypes;
            this.filteredWoType = this.woType.slice();
            this.failMode = res.failureModes;
            this.filteredFailMode = this.failMode.slice();
            this.getOperatorMasterData('change');
            setTimeout(() => {
              this.operator.FailureMode = parseInt(res.result.FailureMode.ID);
            }, 1000);
          }
          this.spinner.hide();
        },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        }
      );
  }
  getOperatorMasterData(type: any) {
    this.spinnerText = 'Fetching Master Data';
    this.spinner.show();
    const data = {
      WOType: this.operator.WOType ? this.operator.WOType : 0,
      group: this.groupSession?.groupCode,
      plant: this.plantSession?.plantCode,
    };
    this.operatorExecutionService.getOperatorMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          if (type != 'change') {
            if (res.WOTypes && res.WOTypes.length) {
              this.woType = res.WOTypes;
              this.filteredWoType = this.woType.slice();
              this.operator.WOType = this.woType[0].ID;
              this.getFailureData('not change');
            }
          } else {
            this.failMode = res.failureModes;
            this.filteredFailMode = this.failMode.slice();
            if (this.filteredFailMode && this.filteredFailMode.length) {
              this.operator.FailureMode = this.failMode[0].ID
                ? this.failMode[0].ID
                : '';
            }
          }
        } else this.toaster.error('Error', res.message);
      },
      (err) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }
  getFailureData(type: any) {
    this.spinnerText = 'Fetching Master Data';
    this.spinner.show();
    const data = {
      WOType: this.operator.WOType,
      group: this.groupSession?.groupCode,
      plant: this.plantSession?.plantCode,
    };
    this.operatorExecutionService.getOperatorMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          if (type != 'change') {
            if (res.WOTypes && res.WOTypes.length) {
              this.woType = res.WOTypes;
              this.filteredWoType = this.woType.slice();
              this.operator.WOType = this.woType[0].ID;
            }
            if (res.failureModes && res.failureModes.length) {
              this.failMode = res.failureModes;
              this.filteredFailMode = this.failMode.slice();
              this.operator.FailureMode = this.failMode[0].ID
                ? this.failMode[0].ID
                : '';
            }
          } else {
            this.failMode = res.failureModes;
            this.filteredFailMode = this.failMode.slice();
            if (this.filteredFailMode && this.filteredFailMode.length) {
              this.operator.FailureMode = this.failMode[0].ID
                ? this.failMode[0].ID
                : '';
            }
          }

          if (this.operator.WOType && this.failMode && !this.failMode.length)
            this.toaster.warning(
              'Warning',
              'Failure Mode Data Not Found For This WO Type'
            );
        } else this.toaster.error('Error', res.message);
      },
      (err) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }
  openTimePicker(timepicker: { open: () => void }) {
    timepicker.open();
  }

  get of() {
    return this.operatorForm.controls;
  }

  openFile() {
    this.fileInput.nativeElement.click();
  }

  readFile(event: any) {
    const files = event.target.files;
    if (files) {
      for (let file of files) {
        if (file.type.match('image.*')) {
          this.fileType = 'image';
          this.FileList.push(file);
        } else {
          this.toaster.warning('Warning', 'File Format Not Valid ');
          return;
        }
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
          this.FileData.push({
            FileType: this.fileType,
            ImageSrc: this.imageSrc,
          });
        };
        reader.readAsDataURL(file);
      }
      event.target.value = '';
    }
  }

  removeFile(i: any) {
    this.FileData.splice(i, 1);
    this.FileList.splice(i, 1);
  }

  deleteFile(i: any) {
    this.EditFileData.splice(i, 1);
    this.operator.UploadPicture.push(i);
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  onSubmit(formDirective: FormGroupDirective) {
    this.operatorForm.get('group')?.setValue(this.groupSession?.groupCode);
    this.operatorForm.get('plant')?.setValue(this.plantSession?.plantCode);
    if (this.operatorForm.invalid) {
      this.toaster.warning('Please Fill All Required Field', 'Error', {
        timeOut: 3000,
      });
      return;
    } else {
      if (this.operator.SpareParts == true) {
        this.operator.SpareParts = 1;
      } else {
        this.operator.SpareParts = 0;
      }
      this.formDirective = formDirective;
      const formData = new FormData();
      for (const file of this.FileList)
        formData.append('image', file, file.name);
      this.operator.RequestedBy = this.operator.createdBy;
      formData.append('data', JSON.stringify(this.operator));
      this.spinnerText = 'Creating Work Order';

      // console.log("Data");
      // const Data = {
      //   PlantID: this.plantSession?.plantCode,
      //   MachineID: this.operator.units,
      //   UserID: this.userSession?.userCode,
      //   WorkOrderId: 39,
      //   WorkOrderDetail : this.operator.Remark,
      //   CreatedAt: new Date(),
      // }
      // console.log(Data)

      this.spinner.show();
      if (!this.isEdit) {
        this.operatorExecutionService.createWorkOrder(formData).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.formDirective.resetForm();
            this.operatorForm.reset();
            this.router.navigate(['/PM/OperatorExecutionWindow']);
            if (res.status) {
              if (res.result) {
              }
              this.toaster.success('Success', res.message);
            } else this.toaster.error('Error', res.message);
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      } else {
        this.operatorExecutionService.updateWorkOrder(formData).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.isEdit = false;
            this.formDirective.resetForm();
            this.operatorForm.reset();
            this.router.navigate(['/PM/OperatorExecutionWindow']);
            if (res.status) {
              if (res.result) {
              }
              this.operator.UploadPicture = [];
              this.toaster.success('Success', res.message);
            } else this.toaster.error('Error', res.message);
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }

  getTreeMasterData() {
    const data = {
      GroupCode: this.groupSession?.groupCode,
      PlantCode: this.plantSession?.plantCode,
    };
    this.spinner.show();
    this.prevConfigurationService.GetTreeMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.LineAllList = [];
        this.LineList = [];
        this.LineFilterList = [];
        this.UnitAllList = [];
        this.UnitList = [];
        this.UnitFilterList = [];
        this.AssemblyAllList = [];
        this.AssemblyList = [];
        this.AssemblyFilterList = [];
        this.SubAssemblyAllList = [];
        this.SubAssemblyList = [];
        this.SubAssemblyFilterList = [];
        this.ComponentAllList = [];
        this.ComponentList = [];
        this.ComponentFilterList = [];
        this.LineAllList = res.Line;
        this.LineList = res.Line;
        this.UnitAllList = res.Unit;
        this.AssemblyAllList = res.Assembly;
        this.SubAssemblyAllList = res.SubAssembly;
        this.ComponentAllList = res.Component;
        this.LineFilterList = this.LineList.slice();
        if (this.LineFilterList && this.LineFilterList.length) {
          if (this.operator.line) {
            const find = this.LineFilterList.find(
              (ln: any) => ln.PL_Id == this.operator.line
            );
            this.operator.line = find ? find.PL_Id : this.LineList[0].PL_Id;
          } else
            this.operatorForm.get('line')?.setValue(this.LineList[0].PL_Id);
        }
        // this.setUnitList('notChange');
        // this.getUnitData();
        // this.setNewUnitList('notChange');
        // this.setAssemblyList('notChange');
        // this.setSubAssemblyList('notChange');
        // this.setComponentList('notChange');

        this.getUnitData().then(() => {
          this.setNewUnitList('notChange');
          this.setAssemblyList('notChange');
          this.setSubAssemblyList('notChange');
          this.setComponentList('notChange');
        });
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  setNewUnitList(type: any) {
    this.NewUnitList = [];
    this.NewUnitFilterList = [];
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];

    let unitList = this.UnitAllList.filter(
      (unit: any) => unit.PL_Id == this.operator.line
    );
    if (type == 'change') {
      this.operator.units = '';
      this.operator.assembly = '';
      this.operator.subAssembly = '';
      this.operator.component = '';
    }
    else {
      if (unitList && unitList.length) {
        this.NewUnitList = unitList;
        this.NewUnitFilterList = this.NewUnitList.slice();
        if (this.NewUnitFilterList && this.NewUnitFilterList.length) {
          if (this.operator.units) {
            const find = this.NewUnitFilterList.find(
              (un: any) => un.PU_Id == this.operator.units
            );
            this.operator.units = find ? find.PU_Id : this.NewUnitList[0].PU_Id;
          } else
            this.operatorForm.get('unit')?.setValue(this.NewUnitList[0].PU_Id);
        }
      }
    }
    if (unitList && unitList.length) {
      this.NewUnitList = unitList;
      this.NewUnitFilterList = this.NewUnitList.slice();
      if (this.NewUnitFilterList && this.NewUnitFilterList.length) {
        if (this.operator.units) {
          const find = this.NewUnitFilterList.find(
            (un: any) => un.PU_Id == this.operator.units
          );
          this.operator.units = find ? find.PU_Id : this.NewUnitList[0].PU_Id;
        } else this.operatorForm.get('unit')?.setValue(this.NewUnitList[0].PU_Id);
      }
      if (type == 'change') {
        this.setAssemblyList('change');
      }
    }
  }

  // setUnitList(type: any) {
  //   this.UnitList = [];
  //   this.UnitFilterList = [];
  //   this.AssemblyList = [];
  //   this.AssemblyFilterList = [];
  //   this.SubAssemblyList = [];
  //   this.SubAssemblyFilterList = [];
  //   this.ComponentList = [];
  //   this.ComponentFilterList = [];

  //   let unitList = this.UnitAllList.filter(
  //     (unit: any) => unit.PL_Id == this.operator.line
  //   );
  //   if (type == 'change') {
  //     this.operator.units = '';
  //     this.operator.assembly = '';
  //     this.operator.subAssembly = '';
  //     this.operator.component = '';
  //   } 
  //   else {
  //     if (unitList && unitList.length) {
  //       this.UnitList = unitList;
  //       this.UnitFilterList = this.UnitList.slice();
  //       if (this.UnitFilterList && this.UnitFilterList.length) {
  //         if (this.operator.units) {
  //           const find = this.UnitFilterList.find(
  //             (un: any) => un.PU_Id == this.operator.units
  //           );
  //           this.operator.units = find ? find.PU_Id : this.UnitList[0].PU_Id;
  //         } else
  //           this.operatorForm.get('unit')?.setValue(this.UnitList[0].PU_Id);
  //       }
  //     }
  //   }
  //   if (unitList && unitList.length) {
  //     this.UnitList = unitList;
  //     this.UnitFilterList = this.UnitList.slice();
  //     if (this.UnitFilterList && this.UnitFilterList.length) {
  //       if (this.operator.units) {
  //         const find = this.UnitFilterList.find(
  //           (un: any) => un.PU_Id == this.operator.units
  //         );
  //         this.operator.units = find ? find.PU_Id : this.UnitList[0].PU_Id;
  //       } else this.operatorForm.get('unit')?.setValue(this.UnitList[0].PU_Id);
  //     }
  //     if (type == 'change') {
  //       this.setAssemblyList('change');
  //     }
  //   }
  // }

  setAssemblyList(type: any) {
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let assemblyList = this.AssemblyAllList.filter(
      (assembly: any) => assembly.PU_Id == this.operator.units
    );
    if (type == 'change') {
      this.operator.assembly = '';
      this.operator.subAssembly = '';
      this.operator.component = '';
    } else {
      if (assemblyList && assemblyList.length) {
        this.AssemblyList = assemblyList;
        this.AssemblyFilterList = this.AssemblyList.slice();
        if (this.AssemblyFilterList && this.AssemblyFilterList.length) {
          if (this.operator.assembly) {
            const find = this.AssemblyFilterList.find(
              (asm: any) => asm.Assbly_Id == this.operator.assembly
            );
            this.operator.assembly = find
              ? find.Assbly_Id
              : this.AssemblyList[0].Assbly_Id;
          } else
            this.operatorForm
              .get('assembly')
              ?.setValue(this.AssemblyList[0].Assbly_Id);
        }
      }
    }

    if (assemblyList && assemblyList.length) {
      this.AssemblyList = assemblyList;
      this.AssemblyFilterList = this.AssemblyList.slice();
      if (this.AssemblyFilterList && this.AssemblyFilterList.length) {
        if (this.operator.assembly) {
          const find = this.AssemblyFilterList.find(
            (asm: any) => asm.Assbly_Id == this.operator.assembly
          );
          this.operator.assembly = find
            ? find.Assbly_Id
            : this.AssemblyList[0].Assbly_Id;
        } else
          this.operatorForm
            .get('assembly')
            ?.setValue(this.AssemblyList[0].Assbly_Id);
      }
      if (type == 'change' && assemblyList.length == 1) {
        this.operator.assembly = this.AssemblyList[0].Assbly_Id
          ? this.AssemblyFilterList[0].Assbly_Id
          : '';
        this.setSubAssemblyList('change');
      }
      else {
        this.setSubAssemblyList('change');
      }
    }
  }

  setSubAssemblyList(type: any) {
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let subassemblyList = this.SubAssemblyAllList.filter(
      (subassembly: any) => subassembly.Assbly_Id == this.operator.assembly
    );
    if (type == 'change') {
      this.operator.subAssembly = '';
      this.operator.component = '';
    } else {
      if (subassemblyList && subassemblyList.length) {
        this.SubAssemblyList = subassemblyList;
        this.SubAssemblyFilterList = this.SubAssemblyList.slice();
        if (this.SubAssemblyFilterList && this.SubAssemblyFilterList.length) {
          if (this.operator.subAssembly) {
            const find = this.SubAssemblyFilterList.find(
              (asm: any) => asm.SAssbly_Id == this.operator.subAssembly
            );
            this.operator.subAssembly = find
              ? find.SAssbly_Id
              : this.SubAssemblyList[0].SAssbly_Id;
          } else
            this.operatorForm
              .get('subAssembly')
              ?.setValue(this.SubAssemblyList[0].SAssbly_Id);
        }
      }
    }

    if (subassemblyList && subassemblyList.length) {
      this.SubAssemblyList = subassemblyList;
      this.SubAssemblyFilterList = this.SubAssemblyList.slice();
      if (type == 'change' && subassemblyList.length == 1) {
        if (this.SubAssemblyFilterList && this.SubAssemblyFilterList.length) {
          if (this.operator.subAssembly) {
            const find = this.SubAssemblyFilterList.find(
              (asm: any) => asm.SAssbly_Id == this.operator.subAssembly
            );
            this.operator.subAssembly = find
              ? find.SAssbly_Id
              : this.SubAssemblyList[0].SAssbly_Id;
          } else
            this.operatorForm
              .get('subAssembly')
              ?.setValue(this.SubAssemblyList[0].SAssbly_Id);
        }
        this.setComponentList('change');
      }
      else {
        this.operatorForm
          .get('subAssembly')
          ?.setValue(this.SubAssemblyList[0].SAssbly_Id);
        this.setComponentList('change');
      }
    }
    else {
    }
  }

  setComponentList(type: any) {
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let componentList = this.ComponentAllList.filter(
      (component: any) => component.SAssbly_Id == this.operator.subAssembly
    );
    if (type == 'change') {
      this.operator.component = '';
      if (componentList && componentList.length)
        this.operator.component = componentList[0].ComponentId
          ? componentList[0].ComponentId
          : '';
    } else {
      if (componentList && componentList.length) {
        this.ComponentList = componentList;
        this.ComponentFilterList = this.ComponentList.slice();
        if (this.ComponentFilterList && this.ComponentFilterList.length) {
          if (this.operator.component) {
            const find = this.ComponentFilterList.find(
              (asm: any) => asm.ComponentId == this.operator.component
            );
            this.operator.component = find
              ? find.ComponentId
              : this.ComponentList[0].ComponentId;
          } else
            this.operatorForm
              .get('component')
              ?.setValue(this.ComponentList[0].ComponentId);
        }
      }
    }

    if (componentList && componentList.length) {
      this.ComponentList = componentList;
      this.ComponentFilterList = this.ComponentList.slice();
      if (this.ComponentFilterList && this.ComponentFilterList.length) {
        if (this.operator.component) {
          const find = this.ComponentFilterList.find(
            (asm: any) => asm.ComponentId == this.operator.component
          );
          this.operator.component = find
            ? find.ComponentId
            : this.ComponentList[0].ComponentId;
        } else
          this.operatorForm
            .get('component')
            ?.setValue(this.ComponentList[0].ComponentId);
      }
      if (type == 'change' && componentList.length == 1) {
        this.operator.component = this.ComponentList[0].ComponentId
          ? this.ComponentList[0].ComponentId
          : '';
      }
    } else {
    }
  }

  searchValues(filter: any, type: string) {
    filter = filter.target.value;
    if (type === 'woType')
      this.filteredWoType = this.woType.filter((wo: any) => {
        let lowerCase = wo.Name.toLocaleLowerCase();
        return wo.Name.startsWith(filter) || lowerCase.startsWith(filter);
      });
    else if (type === 'failMode')
      this.filteredFailMode = this.failMode.filter((fm: any) => {
        let lowerCase = fm.Name.toLocaleLowerCase();
        return fm.Name.startsWith(filter) || lowerCase.startsWith(filter);
      });
  }

  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  addUserWiseNotification(val: any) {
    let userIds: any[] = val.assignUser;
    const data = {
      userId: userIds,
      desc:
        val.operExecWo.WOStatus == 1
          ? `Work Order ID ${val.operExecWo.WOId} Is Opened`
          : val.operExecWo.WOStatus == 2
            ? `Work Order ID ${val.operExecWo.WOId} Is Closed`
            : val.operExecWo.WOStatus == 3
              ? `Work Order ID ${val.operExecWo.WOId} Is Completed`
              : val.operExecWo.WOStatus == 4
                ? `Work Order ID ${val.operExecWo.WOId} Is Delayed`
                : val.operExecWo.WOStatus == 6
                  ? `Work Order ID ${val.operExecWo.WOId} Is Reopened`
                  : `Work Order ID ${val.operExecWo.WOId} Is Inprogress`,
      title: 'Work Order',
      createdBy: JSON.parse(localStorage.user).UserId,
    };
    this.spinnerText = 'Adding User Wise Notification';
    this.spinner.show();
    this.prevConfigurationService.addUserWiseNotification(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Success', res.message);
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  addRoleWiseNotification() {
    const data = {
      // egId: this.groupDataForm.get('group')?.value,
      // createdBy: JSON.parse(localStorage.user).UserId,
      // desc: description,
      // title: 'Checklist Execution History',
      // roleName: role. // multiple role names
    };
    this.spinnerText = 'Adding Role Wise Notification';
    this.spinner.show();
    this.prevConfigurationService.addRoleWiseNotification(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Success', res.message);
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  addDepartmentWiseNotification() {
    const data = {
      // roleName: 'Section Manager',
      // egId: this.DefectDataForm.value.group,
      // departmentId: this.addNewVariableItemlForm.value.department,
      // createdBy: JSON.parse(localStorage.user).UserId,
      // desc: descr,
      // title: 'Defect Management'
    };
    this.spinnerText = 'Adding Department Wise Notification';
    this.spinner.show();
    this.prevConfigurationService.addDepartmentWiseNotification(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Success', res.message);
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
}
